<template>
    <ManageIntegrationBase
      :integration="integration"
      :show="show"
      :showAuthSuccess="showAuthSuccess"
      :title="$t('companySettings.integrations.capsule.name')"
      @loadingStateChanged="reEmitLoadingStateChanged"
      @close="closeModal"
    >
      <VForm
        :onSubmit="updateSettings"
        data-vv-scope="capsule-edit"
        ref="form">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="12">
              <b>{{ $t('companySettings.integrations.capsule.settings.subdomain') }}</b>
              <VInput
                type="text"
                v-model="settings.subdomain"
                data-ec="manage_capsule_modal"
                data-et="subdomain_input"
                :placeholder="$t('companySettings.integrations.capsule.settings.subdomain')"
              />
            </div>
            <div slot="gridItem" type="12">
              <b>{{ $t('companySettings.integrations.capsule.settings.addnote') }}</b>
              <VCheckbox
                type="checkbox"
                subtype="toggle"
                v-model="settings.addnote"
                :checked="settings.addnote"
                data-ec="manage_capsule_modal"
                data-et="add_note_checkbox"
              />
              <span class="checkbox-status-indicator" >{{ settings.addnote ? $t('functional.enabled') : $t('functional.disabled') }}</span>
            </div>
          </VGrid>
        </div>
        <div slot="formButtons">
          <VButton
            type="cta-1"
            subtype="submit"
            class="float-right"
            href="#"
            data-ec="manage_capsule_modal"
            data-et="save_button">
            <CheckIcon />
            <span>{{ $t('functional.save') }}</span>
          </VButton>
        </div>
      </VForm>
    </ManageIntegrationBase>
</template>

<script>
import { Loading } from 'element-ui';
import ManageIntegrationBase from '@/views/modals/integrations/ManageIntegrationBase.vue';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import integrationsManagementMixin from '@/mixins/integrationsManagementMixin';
import { CheckIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ManageCapsule',
  components: {
    ManageIntegrationBase,
    VButton,
    VCheckbox,
    VInput,
    VForm,
    VGrid,
    CheckIcon,
  },
  mixins: [
    integrationsManagementMixin,
  ],
  props: {
    show: {
      type: [Boolean],
      required: true,
    },
    showAuthSuccess: {
      type: [Boolean],
      required: true,
    },
    integration: {
      type: [Object],
      required: true,
    },
  },
  data() {
    return {
      settings: {
        subdomain: null,
        addnote: false,
      },
    };
  },
  mounted() {
    if (this.hasInstance && this.hasSettings) {
      this.copyIntegrationSettings();
    }
  },
  watch: {
    hasSettings() {
      if (this.hasInstance) {
        this.copyIntegrationSettings();
      }
    },
  },
  methods: {
    updateSettings() {
      const loadingInstance = Loading.service();

      const { settings } = this;

      this.$store.dispatch('integrations/UPDATE_INSTANCE_SETTINGS', {
        slug: 'capsule',
        settings,
      }).finally(() => {
        loadingInstance.close();
        this.$emit('close');
      });
    },
    closeModal() {
      this.$emit('close');
      this.copyIntegrationSettings();
    },
    copyIntegrationSettings() {
      if (this.integration.instance.settings) {
        this.settings.subdomain = this.integration.instance.settings.subdomain;
        this.settings.addnote = this.integration.instance.settings.addnote;

        return;
      }

      this.settings.subdomain = null;
      this.settings.addnote = false;
    },
  },
};
</script>

<style scoped>
.checkbox-status-indicator {
  vertical-align: top;
  line-height: var(--spacing-large);
  margin-left: var(--spacing-base);
  font-weight: bold;
}
</style>
